module.exports = __webpack_public_path__ + "static/media/bytt-nn-16.bea3e1b6.mp3";